export default __webpack_public_path__ + "static/media/ic_send_sp_dark.27c3af57.svg";